export default __webpack_public_path__ + "static/media/wall.a7ded673.webp";